<mat-toolbar color="accent">
  <h2>History</h2>
</mat-toolbar>

<p class="!mx-6 !mt-4 !mb-0 text-sm">
  Report results are saved for <strong>30 days</strong>.
  <strong>Pin</strong> a run to keep it available beyond 30 days.
  <strong>Delete</strong> a run to hide it from the sidebar. You can
  always restore it later.
</p>

<mat-dialog-content class="!max-h-[60vh] !overflow-auto">
  <table
    mat-table
    [dataSource]="dataSource"
    class="w-full rounded border border-slate-200"
  >
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef class="!w-48">Date</th>
      <td mat-cell *matCellDef="let run" class="!w-48">
        @if (run | map: isViewable) {
          <a
            class="text-primary-500 text-sm no-underline hover:underline"
            [routerLink]="data.historyBasePath.concat(run.ref.id)"
            (click)="navigateToRun()"
          >
            {{ run.runAt | moment | amDateFormat: 'DD MMM YYYY, h:mm a' }}
          </a>
        } @else {
          <span class="text-sm text-slate-500">
            {{ run.runAt | moment | amDateFormat: 'DD MMM YYYY, h:mm a' }}
          </span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="relativeTime">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let run">
        <span class="text-xs text-slate-400">
          {{ run.runAt | fromNow$ | async }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="tags">
      <th mat-header-cell *matHeaderCellDef class="!w-36"></th>
      <td mat-cell *matCellDef="let run" class="!w-36">
        @if (run.archivedAt) {
          <span
            class="inline-flex items-center rounded-full bg-red-50 px-2 py-0.5 text-[10px] font-medium text-red-600"
          >
            Deleted
          </span>
        } @else if (run.pinned) {
          <span
            class="bg-primary-50 text-primary-700 inline-flex items-center gap-0.5 rounded-full px-2 py-0.5 text-[10px] font-medium"
          >
            <mat-icon class="icon-xs">push_pin</mat-icon>
            Pinned
          </span>
        } @else if (run.expiresAt) {
            <span
              class="inline-flex items-center rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-medium text-amber-700"
            >
              @if (run | map: isExpiringSoon) {
                Expiring soon
              } @else {
                Expires {{ run.expiresAt.toDate() | date: 'dd/MM/yyyy' }}
              }
            </span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="results">
      <th mat-header-cell *matHeaderCellDef class="!w-24"></th>
      <td mat-cell *matCellDef="let run" class="!w-24 whitespace-nowrap">
        <div>
          @if (run.status === ReportRunStatus.Complete) {
            <span class="text-sm">{{ run.result?.resultCount ?? 0 }} results</span>
          } @else if (run.status === ReportRunStatus.Failed) {
            <span class="text-sm text-red-500">Failed</span>
          }
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="!w-12"></th>
      <td mat-cell *matCellDef="let run" class="!w-12">
        <button mat-icon-button [matMenuTriggerFor]="runMenu">
          <mat-icon>more_vert</mat-icon>
        </button>

        <mat-menu #runMenu="matMenu">
          @if (run | map: isViewable) {
            <a
              mat-menu-item
              [routerLink]="data.historyBasePath.concat(run.ref.id)"
              (click)="navigateToRun()"
            >
              <mat-icon class="opacity-50">visibility</mat-icon>
              <span>View</span>
            </a>
          }
          @if (run | map: isRestorable) {
            <button mat-menu-item (click)="unarchiveRun(run)">
              <mat-icon class="!text-green-500">restore</mat-icon>
              <span>Restore</span>
            </button>
          } @else {
            <button mat-menu-item (click)="togglePin(run)">
              <mat-icon class="opacity-50"> push_pin </mat-icon>
              <span>{{ run.pinned ? 'Unpin' : 'Pin' }}</span>
            </button>
            @if (run | map: isDeletable) {
              <button mat-menu-item (click)="archiveRun(run)">
                <mat-icon color="warn">delete</mat-icon>
                <span>Delete</span>
              </button>
            }
          }
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  @if (dataSource.data.length === 0) {
    <div class="py-8 text-center text-sm opacity-50">No report runs yet</div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <mat-paginator
    [pageSize]="10"
    [pageSizeOptions]="[10, 25, 50]"
    [class.hidden]="dataSource.data.length === 0"
    showFirstLastButtons
  />
  <span class="flex grow"></span>
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
